var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.link
    ? _c("a", { attrs: { href: _vm.link } }, [
        _c("img", {
          staticClass: "entrance_banner_image",
          attrs: {
            src: _vm.thumbnail(_vm.image),
            width: "420",
            height: "124",
            alt: ""
          }
        })
      ])
    : _c("img", {
        staticClass: "entrance_banner_image",
        attrs: {
          src: _vm.thumbnail(_vm.image),
          width: "420",
          height: "124",
          alt: ""
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }